import {
  Input,
  Flex,
  Textarea,
  Spacer,
  Fieldset,
  Stack,
  Text,
  Select,
  createListCollection,
  HStack,
  Grid,
} from "@chakra-ui/react";
import { toaster } from "../ui/toaster";
import { Field } from "../ui/field";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SimpleOutlineButton } from "./Button";
import { useColorModeValue } from "../ui/color-mode";
import { RadioGroup, Radio } from "../ui/radio";
import {
  FileUploadList,
  FileUploadRoot,
  FileUploadTrigger,
} from "../ui/file-upload";
import { HiUpload } from "react-icons/hi";
import UploadFile from "./UploadFile";

const ItrForm = () => {
  const [showFileUpload, setShowFileUpload] = useState(false);
  const nature = createListCollection({
    items: [
      { label: "Central govt employee", value: "central gov" },
      { label: "State govt employee", value: "state gov" },
      { label: "Others", value: "others" },
      { label: "Pensioners", value: "pensioners" },
    ],
  });

  const secondBg = useColorModeValue("#b8fff7", "#090110");
  const inputBg = useColorModeValue("#f6f6ff", "#251f35");
  const inputBoxShadow = useColorModeValue(
    "rgba(174, 174, 192, 0.4) 3px 3px 6px 0px inset, rgba(255, 255, 255, 0.5) -3px -3px 6px 1px inset;",
    "rgba(174, 174, 192, 0.1) 3px 3px 6px 0px inset, rgba(255, 255, 255, 0.1) -3px -3px 6px 1px inset;"
  );
  const focusShadow = useColorModeValue(
    "inset 6px 6px 10px rgba(174, 174, 192, 0.4), inset -6px -6px 10px #fff",
    "inset 6px 6px 10px rgba(174, 174, 192, 0.1), inset -6px -6px 10px #fff"
  );

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const formData = new FormData(e.target);

    try {
      const res = await fetch("https://formspree.io/f/mzzrokvo", {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
        },
      });

      if (res.ok) {
        navigate("/");
        window.scrollTo({ top: 0, behavior: "auto" });

        const promise = new Promise((resolve) => setTimeout(resolve, 2000));

        toaster.promise(promise, {
          success: {
            title: "Form submitted!",
            description: "We'll get back to you soon",
          },
          error: {
            title: "Submission failed",
            description: "Something went wrong",
          },
          loading: {
            title: "Submitting...",
            description: "Please wait",
          },
        });
      } else {
        throw new Error("Form submission failed");
      }
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  return (
    <Flex
      bgColor={secondBg}
      p={{ base: "5", md: "5", lg: "10" }}
      borderRadius="2xl"
      w={{ base: "xs", md: "2xl" }}
      mx="auto"
      my={20}

    >
      <form onSubmit={handleSubmit} style={{ width: "100%" }} enctype="multipart/form-data">
        <Fieldset.Root>
          <Fieldset.Content>
            {/* Name */}
            <Field id="name" required>
              <Input
                type="text"
                name="from_name"
                fontSize="sm"
                placeholder="Assessee Name"
                boxShadow={inputBoxShadow}
                borderRadius="xl"
                _focus={{
                  borderColor: "#008080",
                  boxShadow: { focusShadow },
                }}
                bgColor={inputBg}
                h="50px"
              />
              <Text fontSize="sm" color="gray.500">
                (Please enter name same as per PAN Card)
              </Text>
            </Field>
            <Spacer h="10" />

            {/* Pan Card Number */}
            <Field id="name" required>
              <Input
                type="text"
                name="pan_number"
                fontSize="sm"
                placeholder="PAN Card Number"
                boxShadow={inputBoxShadow}
                borderRadius="xl"
                _focus={{
                  borderColor: "#008080",
                  boxShadow: { focusShadow },
                }}
                bgColor={inputBg}
                h="50px"
              />
            </Field>
            <Spacer h="10" />

            {/* Email & Phone Number */}
            <Stack direction={{ base: "column", md: "row" }} gap={4}>
              <Field id="email" required>
                <Input
                  type="email"
                  name="from_email"
                  fontSize="sm"
                  placeholder="Email Address"
                  boxShadow={inputBoxShadow}
                  borderRadius="xl"
                  _focus={{
                    borderColor: "#008080",
                    boxShadow: { focusShadow },
                  }}
                  bgColor={inputBg}
                  h="50px"
                />
              </Field>
              <Spacer h="10" />

              <Field id="number" required>
                <Input
                  type="text"
                  name="from_number"
                  fontSize="sm"
                  placeholder="Phone number"
                  boxShadow={inputBoxShadow}
                  borderRadius="xl"
                  _focus={{
                    borderColor: "#008080",
                    boxShadow: { focusShadow },
                  }}
                  bgColor={inputBg}
                  h="50px"
                />
              </Field>
            </Stack>
            <Spacer h="10" />

            {/* Present Address */}
            <Field id="message" required>
              <Textarea
                type="text"
                name="Present Address"
                fontSize="sm"
                placeholder="Present Address"
                boxShadow={inputBoxShadow}
                borderRadius="xl"
                _focus={{
                  borderColor: "#008080",
                  boxShadow: { focusShadow },
                }}
                bgColor={inputBg}
                h="120px"
              />
              <Text fontSize="sm" color="gray.500">
                (Please include H.No, Steet/Village, Taluka, District and Pin
                Code)
              </Text>
            </Field>
            <Spacer h="10" />

            {/* Nature of Employment */}
            <Select.Root collection={nature}>
              <Select.Label color="gray.500" fontSize="sm">
                Nature of Employment
              </Select.Label>
              <Select.Trigger
                boxShadow={inputBoxShadow}
                borderRadius="xl"
                _focus={{
                  borderColor: "#008080",
                  boxShadow: { focusShadow },
                }}
                bgColor={inputBg}
                h="50px"
              >
                <Select.ValueText placeholder="Select Employment" />
              </Select.Trigger>
              <Select.Content
                boxShadow={inputBoxShadow}
                borderRadius="xl"
                _focus={{
                  borderColor: "#008080",
                  boxShadow: { focusShadow },
                }}
                bgColor={inputBg}
              >
                {nature.items.map((nature) => (
                  <Select.Item item={nature} key={nature.value}>
                    {nature.label}
                  </Select.Item>
                ))}
              </Select.Content>
            </Select.Root>
            <Spacer h="10" />

            {/* Company Name */}
            <Field id="companyName">
              <Input
                type="text"
                name="from_company_name"
                fontSize="sm"
                placeholder="Company Name"
                boxShadow={inputBoxShadow}
                borderRadius="xl"
                _focus={{
                  borderColor: "#008080",
                  boxShadow: { focusShadow },
                }}
                bgColor={inputBg}
                h="50px"
              />
            </Field>
            <Spacer h="10" />

            {/* Housing Loan */}
            <UploadFile
              inputTitle="Housing loan statement"
              fieldId1="houseLoan"
              radioName="loan_statement"
              fieldId2="loanFile"
              fileName="house_loan_file"
            />

            {/* Housing Loan */}
            <UploadFile
              inputTitle="Trading of shares / Securities / Mutual funds / Etc"
              fieldId1="trading"
              radioName="trading"
              fieldId2="tradingFile"
              fileName="trading_file"
            />

            {/* Intrest from banks */}
            <Field id="intrest">
              <Input
                type="text"
                name="intrest_field"
                fontSize="sm"
                placeholder="Interest from saving bank / Deposit / Mutual funds"
                boxShadow={inputBoxShadow}
                borderRadius="xl"
                _focus={{
                  borderColor: "#008080",
                  boxShadow: { focusShadow },
                }}
                bgColor={inputBg}
                h="50px"
              />
            </Field>
            <Spacer h="10" />

            {/* Other Source of Income */}
            <UploadFile
              inputTitle="Any other source of income"
              fieldId1="otherIncome"
              radioName="otherIncome"
              fieldId2="otherIncomeFile"
              fileName="other_income_file"
              outsideNote={
                <Text fontSize="sm" color="gray.500">
                  (Ex: freelancing, foreign income, commission, dividend and
                  etc.)
                </Text>
              }
            />

            {/* Cash Deposits */}
            <Field id="cashDeposit" required>
              <RadioGroup
                name="cash_deposit"
                onChange={(event) =>
                  setShowFileUpload(event.target.value === "yes")
                }
                variant="subtle"
                colorPalette="blue"
              >
                <Grid templateColumns="4fr 1fr" gap={20}>
                  <Text fontSize="sm" color="gray.500">
                    Cash deposits in bank more than 50Lakhs
                  </Text>
                  <HStack gap={4}>
                    <Radio value="yes">Yes</Radio>
                    <Radio value="no">No</Radio>
                  </HStack>
                </Grid>
              </RadioGroup>
            </Field>
            <Spacer h="10" />

            {/* Credit Card Bills */}
            <UploadFile
              inputTitle="Credit card bills more than 5Lakhs"
              fieldId1="creditBills"
              radioName="creditBills"
              fieldId2="creditBillsFile"
              fileName="credit_bills_file"
              maxFiles={6}
              insideNote={
                <Text fontSize="sm" color="gray.500">
                  (Provide the last financial close cc statements)
                </Text>
              }
            />

            {/* Company Stocks */}
            <Field id="companyStock" required>
              <RadioGroup
                name="company_stock"
                onChange={(event) =>
                  setShowFileUpload(event.target.value === "yes")
                }
                variant="subtle"
                colorPalette="blue"
              >
                <Grid templateColumns="4fr 1fr" gap={20}>
                  <Text fontSize="sm" color="gray.500">
                    Company stock options
                  </Text>
                  <HStack gap={4}>
                    <Radio value="yes">Yes</Radio>
                    <Radio value="no">No</Radio>
                  </HStack>
                </Grid>
              </RadioGroup>
            </Field>
            <Spacer h="10" />

            {/* Property */}
            <UploadFile
              inputTitle="Sale of property / Purchase of property"
              fieldId1="property"
              radioName="property"
              fieldId2="propertyFiles"
              fileName="property_files"
              maxFiles={6}
              insideNote={
                <Text fontSize="sm" color="gray.500">
                  (Sale deed & Purchase deed of relevant documents)
                </Text>
              }
            />

            {/* Salary above 50L */}
            <Field id="salary50" required>
              <RadioGroup
                name="salary_50"
                onChange={(event) =>
                  setShowFileUpload(event.target.value === "yes")
                }
                variant="subtle"
                colorPalette="blue"
              >
                <Grid templateColumns="4fr 1fr" gap={20}>
                  <Text fontSize="sm" color="gray.500">
                    Salary above 50Lakhs
                  </Text>
                  <HStack gap={4}>
                    <Radio value="yes">Yes</Radio>
                    <Radio value="no">No</Radio>
                  </HStack>
                </Grid>
              </RadioGroup>
            </Field>
            <Spacer h="10" />

            {/* Remark */}
            <Field id="remarks" required>
              <Textarea
                type="text"
                name="Remarks"
                fontSize="sm"
                placeholder="Remarks (Points to be noted while filing the ITR)"
                boxShadow={inputBoxShadow}
                borderRadius="xl"
                _focus={{
                  borderColor: "#008080",
                  boxShadow: { focusShadow },
                }}
                bgColor={inputBg}
                h="120px"
              />
            </Field>
            <Spacer h="10" />

            {/* Submit Button */}
            <SimpleOutlineButton
              title="Submit"
              isLoading={isLoading}
              loadingText="Sending"
              type="submit"
            />
          </Fieldset.Content>
        </Fieldset.Root>
      </form>
    </Flex>
  );
};

export default ItrForm;
